"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComplaintStatusEnum = void 0;
/** Статус рассмотрения жалобы */
var ComplaintStatusEnum;
(function (ComplaintStatusEnum) {
  /** Ожидает рассмотрения */
  ComplaintStatusEnum[ComplaintStatusEnum["pending"] = 1] = "pending";
  /** В процессе рассмотрения */
  ComplaintStatusEnum[ComplaintStatusEnum["processing"] = 2] = "processing";
  /** Решено */
  ComplaintStatusEnum[ComplaintStatusEnum["resolved"] = 3] = "resolved";
})(ComplaintStatusEnum = exports.ComplaintStatusEnum || (exports.ComplaintStatusEnum = {}));
